<template>
    <div id="account-select-page" class="gradbg">
        <div class="header-panel">
            <h1>Please select the accounts you wish to use</h1>
        </div>
        <div class="form-panel">
            <form @submit.prevent="setAccounts(); postSave()">
                <div class="field full">
                    <label for="checking-acct">Checking</label>
                    <select id="checking-acct" v-model="checking" required>
                        <option value>--</option>
                        <option v-for="acct in checkingAccounts" :key="acct.accountId" :value="acct.accountId">{{ acct.accountNumber }}</option>
                    </select>
                </div>
                <div class="field full">
                    <label for="savings-acct">Savings</label>
                    <select id="savings-acct" v-model="savings" required>
                        <option value>--</option>
                        <option v-for="acct in savingsAccounts" :key="acct.accountId" :value="acct.accountId">{{ acct.accountNumber }}</option>
                    </select>
                    <p class="new-savings"><a href="javascript:void(0)">Open a new Savings Account</a></p>
                </div>
                <div class="actions">
                    <button type="submit" v-if="savingsAccounts.length > 0">
                        Save
                    </button>
                    <button type="button" v-else @click.prevent="openAccount">
                        Open New Account
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import {mapState,mapGetters} from 'vuex'

import {fakeAccounts} from '../fakeData'

export default {
    name: 'account-select',
    data() {
        return {
            checking: '',
            savings: '',
            saved: false,
        }
    },
    computed: {
        ...mapState(['bankInfo']),
        ...mapGetters(['activeCheckingAccount', 'activeSavingsAccount']),
        checkingAccounts() {
            if (this.bankInfo.accounts) {
                return this.bankInfo.accounts.filter(a => a.accountType == 'CHK')
            }
            return []
        },
        savingsAccounts() {
            if (this.bankInfo.accounts) {
                return this.bankInfo.accounts.filter(a => a.accountType == 'SAV')
            }
            return []
        },
    },
    methods: {
        setAccounts() {
            this.saved = true
            this.$store.dispatch('setAccounts', {
                savings: this.savings,
                checking: this.checking,
            })

            // this.$router.push('/main/add-funds')
        },
        openAccount() {
            let bank = Object.assign({}, this.bankInfo)   
            let acct = fakeAccounts(1, true)
            bank.accounts = bank.accounts.concat(acct)

            this.$store.dispatch('setBankInfo', bank)
            this.savings = acct[0].accountId
        },
        postSave() {
            this.$router.push('/main/add-funds')
        }
    },
    mounted() {
        if (this.activeCheckingAccount) {
            this.checking = this.activeCheckingAccount.accountId
        }
        else if (this.checkingAccounts.length >= 1) {
            this.checking = this.checkingAccounts[0].accountId
        }

        if (this.activeSavingsAccount) {
            this.savings = this.activeSavingsAccount.accountId
        }
        else if (this.savingsAccounts.length >= 1) {
            this.savings = this.savingsAccounts[0].accountId
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!this.saved) {
            this.setAccounts()
        }
        next()
    },
}
</script>
<style lang="scss">
#account-select-page {
    flex: 1 1 100%;

    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    .form-panel {
        padding: 32px 8px 0;
        flex: 1 1 100%;
        background: white;

        .field.full {
            margin-bottom: 32px;

            p {
                width: 85vmin;
                max-width: 300px;
                margin: 12px auto 0;
                font-size: 12px;
                text-align: left;
            }
        }

        p.new-savings {
            margin-top: 12px;
            a {
                color: black;
            }
        }

        label {
            font-weight: bold;
            text-transform: uppercase;
            margin-bottom: 4px;
        }
        select {
            border: solid 1px #a9a9a9;
            border-radius: 2px;
            width: 85vmin;
            max-width: 300px;

            background-repeat: no-repeat;
            background-position: 98% 50%;
            background-size: 14px;
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 20"><path fill="%23a9a9a9" d="M0,0 L32,0 L16,20" stroke-width="0.5" stroke="%23a9a9a9" stroke-linejoin="round" /></svg>');
        }

        button {
            background: #095E90;
            background-image: linear-gradient(to bottom, #095E90 0%, #055282 100%);
            color: white;
            font-size: 14px;
            padding: 10px 14px;
            border-radius: 8px;
        }
    }
}
</style>
